/**
 * Static mint square grid with a soft glow at the top, fading into the
 * `#f8faf9` canvas. Decorative; the parent supplies `relative isolate` and the
 * canvas color.
 */
export function FeedBotGridBackdrop(): React.JSX.Element {
  return (
    <>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 bg-[linear-gradient(to_right,rgba(23,126,103,0.075)_1px,transparent_1px),linear-gradient(to_bottom,rgba(23,126,103,0.075)_1px,transparent_1px)] [background-size:44px_44px] [background-position:center_top] [mask-image:radial-gradient(ellipse_75%_58%_at_50%_0%,#000_25%,transparent_100%)]"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_55%_40%_at_50%_0%,rgba(85,188,166,0.16),transparent_72%)]"
      />
    </>
  );
}
